import script from "./HomeWorkPage.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeWorkPage.vue?vue&type=script&setup=true&lang=js"

import "./HomeWorkPage.vue?vue&type=style&index=0&id=17155441&lang=css"

const __exports__ = script;

export default __exports__